
import { GenericEntityMetadata, PropertyMetadata, nullIfContainsNull } from '@scisys-uim/uim-common';


export class TextSectionMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('TextSection', {
      id: <PropertyMetadata> {
        name: 'id',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 100,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      text: <PropertyMetadata> {
        name: 'text',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.id;
    return nullIfContainsNull(result);
  }
}



